import React from 'react';

import { AiOutlinePlayCircle } from 'react-icons/ai';
import Modal from 'react-modal';
import ModalVideo from 'react-modal-video';
import ReactTooltip from 'react-tooltip';

import TenantConfig from '../../../config';
import { isPropertyInSection } from '../../../helpers/applicationHelp';
import { sanitizeHtml, sanitizeHtmlNoLink } from '../../../helpers/format';
import { ModalImage } from '../../FormElements';
import OfferDetail from '../../common/OfferDetail';
import Stepper from '../../common/Stepper';

export const RenderMainContent = ({
  error,
  properties,
  sections,
  handleChangeSectionIndex,
  setShowVideoModal,
  showVideoModal,
  features,
  renderPropertyArea,
  isInitialSubmission,
  applicationEditable,
  handleSaveComeAndComeBack,
  isSubmitButtonDisabled,
  handleSubmit,
  modalConsent,
  modalIsOpen,
  closeModal,
  consentFeatures,
  renderConsentCheckbox,
  navigateToDashboard,
}) => {
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };
  const demoLink = TenantConfig?.review?.demoLink;
  return (
    <div className={TenantConfig?.review.mainClassName}>
      {TenantConfig?.stepper.showApplyStep && (
        <div>
          <Stepper
            sections={sections}
            activeIndex={{
              sectionIndex: sections.length - 1,
              propertyIndex: 0,
            }}
            completed={sections.length}
            handleChangeSectionIndex={handleChangeSectionIndex}
            isClickable={TenantConfig?.stepper.clickable}
          />
          <OfferDetail />
        </div>
      )}

      <h1 className="title">
        {TenantConfig?.review.title}
        {demoLink && (
          <span className="demoLink" onClick={() => setShowVideoModal(true)}>
            <AiOutlinePlayCircle /> Help
          </span>
        )}
        {demoLink?.includes('.mp4') ? (
          <ModalVideo
            channel="custom"
            isOpen={showVideoModal}
            url={demoLink}
            onClose={() => setShowVideoModal(false)}
          />
        ) : (
          <ModalImage
            isOpen={showVideoModal}
            src={demoLink}
            onClose={() => setShowVideoModal(false)}
          />
        )}
      </h1>
      <h3
        className="subtitle"
        dangerouslySetInnerHTML={{
          __html: sanitizeHtmlNoLink(TenantConfig?.review.subTitle),
        }}
      />
      <div className="validation-result">
        {error && (
          <p
            className="error-text grouped"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(error),
            }}
          />
        )}
      </div>

      {sections.map((section, sectionIndex) => (
        <React.Fragment key={'section' + sectionIndex}>
          {properties
            .filter((property) => isPropertyInSection(features, section, property))
            .map((property, propertyIndex) => {
              return renderPropertyArea(property, propertyIndex, sectionIndex);
            })}
        </React.Fragment>
      ))}
      {!!TenantConfig?.review?.preSubmitText && isInitialSubmission && (
        <div
          className="presubmitText"
          dangerouslySetInnerHTML={{
            __html: sanitizeHtmlNoLink(TenantConfig?.review?.preSubmitText),
          }}
        />
      )}
      <div
        className={`${!!TenantConfig?.review?.preSubmitText ? '' : 'd-flex'} justify-content-end`}
      >
        <div className="d-inline-block">
          {consentFeatures?.map((consentFeature, index) => {
            return <div key={index}>{renderConsentCheckbox(consentFeature)}</div>;
          })}
        </div>
      </div>
      <div className="validation-result">
        {error && (
          <p
            className="error-text grouped"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtmlNoLink(error),
            }}
          />
        )}
      </div>
      {applicationEditable ? (
        <div className="button-groups d-flex">
          <div>
            <button className="outline-btn" onClick={handleSaveComeAndComeBack}>
              Save and Come Back Later
            </button>
          </div>
          <div>
            <button
              className="primary-btn"
              disabled={isSubmitButtonDisabled}
              onClick={handleSubmit}
            >
              {TenantConfig?.review?.submitButtonText}
            </button>
          </div>
        </div>
      ) : (
        <div className="button-groups d-flex">
          <div />
          <div>
            <button
              className="primary-btn"
              disabled={isSubmitButtonDisabled}
              onClick={navigateToDashboard}
            >
              I am done with edits
            </button>
          </div>
        </div>
      )}
      {TenantConfig?.review?.showMessageForSubmitApp === true && (
        <div>
          <b>
            You must click 'Submit Application for Review' to be considered for a grant. Once you
            submit your application ,you will not be able to change responses.
            <br />
          </b>
          <br />
        </div>
      )}

      {modalConsent &&
        (modalConsent.format?.modalContent || modalConsent.format?.terms?.modalContent) && (
          <Modal
            isOpen={modalIsOpen}
            style={customStyles}
            contentLabel="T&C modal"
            className="field-modal"
            onRequestClose={closeModal}
          >
            <span onClick={closeModal}>x</span>
            <div
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(
                  modalConsent.itemType === 'SimpleProperty'
                    ? modalConsent.format.modalContent
                    : modalConsent.format.terms?.modalContent
                ),
              }}
            />
            <div className="btn-line">
              <button onClick={closeModal} className="btn">
                OK
              </button>
            </div>
          </Modal>
        )}
      <ReactTooltip
        className="tooltip"
        place="bottom"
        textColor="#fcfcfaff"
        backgroundColor="#423176ff"
        effect="solid"
        html={true}
      />
    </div>
  );
};
